"use strict";

import getNgModule from "getNgModule";

const ngModule = getNgModule(__filename);

ngModule.directive("obsLeafletMap", function ($q, $timeout, leafletDefaultConfig) {
    return {
        restrict: "E",
        scope: true,
        require: ["obsLeafletMap", "^obsMapManager"],
        replace: true,
        template: require("./obsLeafletMap.html"),
        link: function ($scope, $el, $attrs, controllers) {
            var ctrl = controllers[0],
                mapManagerCtrl = controllers[1];

            ctrl.initialize(mapManagerCtrl);
        },
        controller: function ($scope, $element) {

            var ctrl = this,
                updateHandler = null,
                managerCtrl = null;

            ctrl.initialize = function (_managerCtrl) {
                managerCtrl = _managerCtrl;
                $scope.mapConfig = _.extend(angular.copy(leafletDefaultConfig), {});
                ctrl.listenToEvents();
            };

            ctrl.listenToEvents = function () {

                $scope.$on("obs:data-load:start", function () {
                    ctrl.showLoader();
                });

                $scope.$on("obs:data-load:success", function (e, mapData) {
                    ctrl.updateMapData(mapData);
                    ctrl.hideLoader();
                });

            };

            ctrl.updateMapData = function (mapData) {
                if (updateHandler != null) {
                    updateHandler(mapData);
                }
            };

            ctrl.showLoader = function () {
                ctrl.getMap().then(function (map) {
                    map.loaderControl.showLoader();
                });
            };

            ctrl.hideLoader = function () {
                $timeout(function () {
                    // parfois ctrl non défini (sur une destruction sans doute)...
                    if (ctrl != null) {
                        let res = ctrl.getMap();
                        if (res != null) {
                            res.then(function (map) {
                                map.loaderControl.hideLoader();
                            });
                        }
                    }
                }, 0, false);
            };

            ctrl.setUpdateHandler = function (handler) {
                updateHandler = handler;
            };

            /**
             * @return {Promise}
             */
            ctrl.getMap = function () {
                var mapElement = $element.find(".angular-leaflet-map"),
                    mapController = mapElement.controller("leaflet");
                if (mapController) {
                    return $q.when(mapController.getMap());
                } else {
                    return $q.reject({})
                }
            };

        }
    };
});


// WEBPACK FOOTER //
// ./src/modules/observatoire/ng/common/obsLeafletMap.js